<template>
  <div class="container" v-if="!loading">
    <div class="bg-block">
      <div class="info">
        <div class="title">开通乐沃收银协议</div>
        <div v-html="mainData.content" class="content" v-if="!loading"></div>
      </div>
      <div class="buttons">
        <div class="btn" @click="toStoreWallet">上一步</div>
        <div class="btn" @click="confirm">我同意协议，确认开通</div>
      </div>
    </div>
    <el-dialog
      :visible="dialogVisible"
      title="开通成功"
      @close="toGuide"
      modal-append-to-body
      :append-to-body="true"
      width="380px"
      :close-on-click-modal="false"
    >
      <div class="dialog">
        <p class="content">您的乐沃收银已开通成功，提供相关资料激活即可使用</p>
        <div class="flex btns">
          <div class="cat-btn" @click="toGuide">查看激活资料</div>
        </div>
      </div>
    </el-dialog>
  </div>
  <div
    class="container"
    v-else
    v-loading="loading"
    element-loading-text="加载中"
  ></div>
</template>

<script>
import {
  applyStatusApi,
  applySubmitApi,
  applyClickApi,
  applyDetailApi,
} from "@/api/storeWallet";

export default {
  data() {
    return {
      mainData: {},
      dialogVisible: false,
      loading: true,
    };
  },
  created() {
    applyStatusApi().then((res) => {
      this.loading = true;
      if (res.error_code === 0) {
        this.loading = false;
        applyDetailApi({
          cate_id: 2,
        }).then((res) => {
          this.mainData = res.data.info;
          // 未开通的门店，都需要要进行点击数上报
          applyClickApi({
            article_id: res.data.info.id,
          }).then(() => {});
        });
      }
    });
  },
  methods: {
    confirm() {
      this.dialogVisible = true;

      applySubmitApi().then((res) => {
        if (res.error_code === 0) {
          console.log(res);
        }
      });
    },
    toGuide() {
      this.dialogVisible = false;
      this.$router.push({
        name: "storeWalletAssistment",
      });
    },
    toStoreWallet() {
      this.$router.push({
        name: "storeWallet",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  height: 80vh;
  .bg-block {
    padding: 0 12px 12px 12px;
    background-color: #ffffff;
    border-radius: 4px;
    margin-bottom: 12px;
    .info {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 60px;
      .title {
        font-weight: 700;
        font-size: 18px;
        margin: 30px 0;
        color: #303133;
      }
      /deep/.content {
        height: 65vh;
        border: 1px solid #c1c1c1;
        padding: 20px;
        overflow-y: auto;
        p {
          font-size: 16px !important;
        }
        &::-webkit-scrollbar {
          width: 4px;
          height: 8px;
        }
        &::-webkit-scrollbar-track {
          width: 4px;
          background: none;
        }
        &::-webkit-scrollbar-thumb {
          width: 4px;
          background: #c1c1c1;
          border-radius: 4px;
        }
      }
    }
    .buttons {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 30px 0;
      .btn {
        margin-right: 20px;
        font-size: 16px;
        background: #07d1aa;
        color: white;
        padding: 0 20px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 5px;
      }
      .btn:hover {
        cursor: pointer;
      }
    }
  }
}
.dialog {
  .content {
    font-size: 16px;
    line-height: 20px;
  }
  .btns {
    padding-top: 10px;
    .cat-btn {
      font-size: 16px;
      background: #07d1aa;
      color: white;
      padding: 0 20px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border-radius: 5px;
    }
  }
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
